function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M563.177 0.752382C668.989 12.4086 710.056 145.897 783.181 223.273C836.971 280.192 883.901 336.941 936.082 395.34C1014.37 482.961 1158.69 535.217 1166.67 652.46C1174.32 764.766 1046.76 835.851 971.782 919.801C898.012 1002.4 836.077 1102.7 731.65 1139.55C625.081 1177.16 494.541 1183.46 399.985 1121.56C307.678 1061.14 328.209 915.251 258.43 829.79C191.975 748.403 46.1856 744.078 10.9346 645.089C-24.0511 546.845 31.3 436.347 86.9025 348.123C138.519 266.224 231.448 228.151 309.656 171.11C393.617 109.873 459.889 -10.6258 563.177 0.752382Z"
});

function SvgSmallBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1167,
    height: 1168,
    viewBox: "0 0 1167 1168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBlob);
export default __webpack_public_path__ + "static/media/small_blob.79a5233aa3759393944d1ea6fe4c0121.svg";
export { ForwardRef as ReactComponent };